import { render } from "./CustomDialogConfirmation.vue?vue&type=template&id=618a2811"
import script from "./CustomDialogConfirmation.vue?vue&type=script&lang=js"
export * from "./CustomDialogConfirmation.vue?vue&type=script&lang=js"

import "./CustomDialogConfirmation.vue?vue&type=style&index=0&id=618a2811&lang=css"

import exportComponent from "/var/www/prod/LVCManagerWebsitePerso/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__